import Icon from '../components/Icon.vue'

Icon.register({
  home: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M280.4 148.3c1.8-1.5 5.3-2.7 7.6-2.7 2.4 0 5.8 1.2 7.7 2.7l184.3 151.7v164c0 8.8-7.2 16-16 16l-112-0.3h0c-8.8 0-16-7.2-16-16 0 0 0 0 0-0.1v-95.6c0-8.8-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16v95.7 0c0 8.8-7.1 16-15.9 16l-112.1 0.3c-8.8 0-16-7.2-16-16v-163.9zM571.6 251.5c2.4 2 4.4 6.2 4.4 9.3 0 2.4-1.2 5.8-2.7 7.6l-25.5 31c-2 2.4-6.1 4.4-9.2 4.4-2.4 0-5.8-1.2-7.7-2.8l-235.2-193.7c-1.8-1.5-5.3-2.7-7.7-2.7-2.4 0-5.8 1.2-7.6 2.7l-235.2 193.7c-1.8 1.5-5.3 2.7-7.6 2.7-3.1 0-7.3-2-9.3-4.4l-25.5-31c-1.5-1.8-2.8-5.3-2.8-7.7 0-3.1 2-7.3 4.4-9.3l253.1-208.5c7.3-6 21-10.9 30.5-10.9 9.5 0 23.2 4.9 30.5 10.9l89.5 73.7v-72.6c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v138.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/home.js
// module id = 1459
// module chunks = 0